export default __webpack_public_path__ + "static/Cashflow 101+202-2-7d30394d68e18a51a150c0e219e866bf.jpg";